<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        {{title}}
    </div>
    <div class="myPurchase-dialog-content">
        <div [innerHTML]="contentString"></div>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Close" mat-dialog-close></app-button>
        </div>
    </div>
</div>